export default class UpdateUserPreferences {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid, preferences) {
    try {
      await this.userRepository.updateUserPreferences(uid, {
        ...preferences,
        updatedAt: new Date().toISOString()
      });
      return true;
    } catch (error) {
      console.error('Error updating user preferences:', error);
      return false;
    }
  }
} 